export default "__VITE_ASSET__BHJt3MYC__"